import { Stack } from '@mui/material'
import { type FC } from 'react'
import { type Control } from 'react-hook-form'
import { BarcodeId } from './BarcodeId'
import { Code } from './Code'
import { Name } from './Name'
import { Status } from './Status'
import { type LabelMasterForm } from './labelMasterForm'

type Props = {
  control: Control<LabelMasterForm>
}

export const LabelMasterSaveForm: FC<Props> = ({ control }) => {
  return (
    <Stack spacing={2}>
      <Name control={control} />
      <Status control={control} />
      <Code control={control} />
      <BarcodeId control={control} />
    </Stack>
  )
}
